import styled from "styled-components";
import { colors } from "@/theme";

export const CouponsContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  padding: 12px 16px;
  align-items: center;
  column-gap: 12px;
`;

export const CouponLabelContainer = styled.div`
  color: ${colors.fieldTextHelper};
  font-family: "PF DIN Text Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
`;

export const CouponInputContainer = styled.div``;
